<button class="h-8 w-8 flex items-center justify-center border border-neutral-3 rounded shadow-button hover:shadow-md transition transition-shadow ease-in-out bg-white"
        [attr.aria-label]="ariaLabel">
    <ng-content></ng-content>
</button>
